var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconQuickResponseMulticolor = function IconQuickResponseMulticolor(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 64 64",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#007ff1"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1.524,
    rx: 0.762,
    width: 18.286,
    y: 30.476
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.524,
    rx: 0.762,
    width: 9.143,
    x: 4.571,
    y: 24.381
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.524,
    rx: 0.762,
    width: 9.143,
    x: 4.571,
    y: 36.571
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M62.067 28.911c2.577 1.273 2.577 4.905 0 6.177L26.654 51.532c-1.745.862-3.797-.389-3.797-2.314l1.51-12.778a2.608 2.608 0 012.298-2.272l24.848-1.501c.962-.1.979-1.233 0-1.334l-24.848-1.501a2.606 2.606 0 01-2.299-2.272L22.857 14.78c0-1.925 2.052-3.174 3.797-2.314z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M52.24 32c-.001.309-.246.617-.727.667l-24.848 1.5a2.608 2.608 0 00-2.299 2.273l-1.509 12.778c0 1.925 2.052 3.176 3.797 2.314l35.413-16.444A3.408 3.408 0 0064 32z",
    fill: "#a0e5ff",
    fillRule: "evenodd"
  }));
};

IconQuickResponseMulticolor.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconQuickResponseMulticolor;
//# sourceMappingURL=IconQuickResponseMulticolor.js.map